// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatOutlinedSvg from "@ant-design/icons-svg/es/asn/WechatOutlined";
import AntdIcon from '../components/AntdIcon';

var WechatOutlined = function WechatOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WechatOutlinedSvg
  }));
};

WechatOutlined.displayName = 'WechatOutlined';
export default React.forwardRef(WechatOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WechatOutlined.js
// module id = 2053
// module chunks = 0